/**
 * Interruptor «generar con IA» de un renglón. Es el MISMO aspecto del de OPUS ai (QuotePage): pista de 38×22
 * que se pinta con el color de lo «privado» (morado) al encender y en gris accesible apagada, con la perilla
 * blanca. Se usa en OPUS ci para que el mismo control se vea igual en los dos productos.
 */
import { tokens } from '@fluentui/react-components';

export function InterruptorIa({
  checked,
  onChange,
  title,
  ariaLabel,
  disabled = false,
}: {
  checked: boolean;
  onChange: (siguiente: boolean) => void;
  title?: string;
  ariaLabel: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange(!checked);
      }}
      style={{
        position: 'relative',
        width: 38,
        height: 22,
        borderRadius: 999,
        padding: 0,
        flexShrink: 0,
        border: '1px solid',
        borderColor: checked ? 'var(--privado)' : tokens.colorNeutralStrokeAccessible,
        background: checked ? 'var(--privado)' : tokens.colorNeutralStrokeAccessible,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: 2,
          left: checked ? 18 : 2,
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
          transition: 'left .15s',
        }}
      />
    </button>
  );
}
